var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7538 11.7605L10.649 1.20908C10.0461 0.153935 8.6141 -0.222902 7.55896 0.380037C7.18212 0.606139 6.88065 0.907609 6.72992 1.20908L0.625154 11.7605C0.0222147 12.8157 0.399052 14.2476 1.4542 14.8506C1.83103 15.0767 2.20787 15.1521 2.58471 15.1521H14.7189C16.0001 15.1521 16.9799 14.0969 16.9799 12.891C17.0553 12.4388 16.9045 12.062 16.7538 11.7605ZM8.68947 12.1374C8.23726 12.1374 7.93579 11.8359 7.93579 11.3837C7.93579 10.9315 8.23726 10.63 8.68947 10.63C9.14167 10.63 9.44314 10.9315 9.44314 11.3837C9.44314 11.8359 9.14167 12.1374 8.68947 12.1374ZM9.44314 8.36898C9.44314 8.82119 9.14167 9.12266 8.68947 9.12266C8.23726 9.12266 7.93579 8.82119 7.93579 8.36898V5.35429C7.93579 4.90208 8.23726 4.60061 8.68947 4.60061C9.14167 4.60061 9.44314 4.90208 9.44314 5.35429V8.36898Z",
    fill: "#FFA011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.384614b7603b046b587d8ec8184423d4.svg";
export { ForwardRef as ReactComponent };